module.exports = __webpack_public_path__ + "static/media/hpm-image-4.af99788c.jpeg";